import toastr from 'toastr'
import 'toastr/build/toastr.min.css'


export const notificationOption = {
    preventDuplicates : true,
    positionClass:  "toast-top-right",
    showEasing : "swing",
    closeButton: true,
    hideEasing : "linear",
    showMethod : "fadeIn",
    hideMethod : "fadeOut",
    showDuration : 300,
    hideDuration : 1000,
    timeOut : 2000,
    extendedTimeOut : 1000
}

toastr.options = notificationOption;

export const notify = (flag, message) => {
    toastr.clear();
    if(flag)
        toastr.success(message)
    else
        toastr.error(message)
}


export const notifySuccess = (message) => toastr.success(message);

export const notifyError = (message) => toastr.error(message);


export const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};